import type { Workstation } from "@redotech/redo-fulfillment-common/workstation";
import { PageFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";

export type PersonalizedSlipLabelPrintPrinter =
  Workstation["selectedPrinters"][number];

export function getPersonalizedSlipPrinterForLabelPrint(
  workstation: Pick<Workstation, "selectedPrinters">,
): PersonalizedSlipLabelPrintPrinter | undefined {
  const premiumPrinter = workstation.selectedPrinters.find(
    (printer) => printer.isPremium,
  );
  const letterPrinter = workstation.selectedPrinters.find(
    (printer) => printer.format === PageFormat.Letter,
  );

  return premiumPrinter || letterPrinter;
}

export function getPersonalizedSlipPrinterForLabelPrintFromWorkstations(
  workstations: readonly Workstation[] | undefined,
): PersonalizedSlipLabelPrintPrinter | undefined {
  const premiumPrinter = workstations
    ?.flatMap((workstation) => workstation.selectedPrinters)
    .find((printer) => printer.isPremium);
  const letterPrinter = workstations
    ?.flatMap((workstation) => workstation.selectedPrinters)
    .find((printer) => printer.format === PageFormat.Letter);

  return premiumPrinter || letterPrinter;
}
